import { IconButton, SettingsLineIcon, Tooltip } from "@relex-solutions/fragments"
import { useShowTableManager } from "@relex-solutions/fragments/TableManager"
import { useTranslation } from "react-i18next"
import { CustomerListContent } from "../CustomerListContent/CustomerListContent"
import styles from "./CustomerList.module.css"

export function CustomerList() {
  const { t } = useTranslation()
  const open = useShowTableManager()

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.headerLeft}>
          <h1 className={`${styles.title} fr-text-500`}>{t("customers.pageTitle")}</h1>
        </div>
        <Tooltip title={t("customers.table.openConfiguration")}>
          <IconButton
            aria-label={t("customers.table.openConfiguration")}
            variant="outline"
            onClick={() => {
              open()
            }}
          >
            <SettingsLineIcon />
          </IconButton>
        </Tooltip>
      </header>
      <CustomerListContent />
    </div>
  )
}
